import { Prf } from "../models/prf.model";
import { PrfPhoto } from "../models/prf-photo.model";
import { UuidAndId } from "../models/uuid-and-id";
import { PrfStateModel } from "../state/prf.state";

export namespace PrfActions {
    export class Refresh {
        static readonly type = '[API-PRF] Refresh'
        constructor() {}
    }
    export class IncrementPendingCount {
        static readonly type = '[Network Service-PRF] Increment Pending Count'
        constructor() {}
    }
    export class Init {
        static readonly type = '[API-PRF] Init'
        constructor(public payload: PrfStateModel) {}
    }
    export class Set {
        static readonly type = '[API-PRF] Set'
        constructor(public payload: Prf[]) {}
    }
    export class Merge {
        static readonly type = '[API-PRF] Merge'
        constructor(public payload: Prf[]) {}
    }
    export class AddOne {
        static readonly type = '[UI-PRF] Add One'
        constructor(public payload: Prf) {}
    }
    export class UpdateOne {
        static readonly type = '[UI-PRF] Update One'
        constructor(public payload: Prf) {}
    }
    export class DeleteOne {
        static readonly type = '[UI-PRF] Delete One'
        constructor(public payload: Prf) {}
    }
    export class ApiDeletedOne {
        static readonly type = '[API-PRF] Deleted One'
        constructor(public payload: UuidAndId) {}
    }
    // The server's copy after a POST or PUT of the local PRF uuid, sent when
    // the PRF was at local_rev.
    export class ApiSavedOne {
        static readonly type = '[API-PRF] Saved One'
        constructor(public payload: { uuid: string, local_rev: number | undefined, server: Prf }) {}
    }
    export class ApiPhotoUploaded {
        static readonly type = '[API-PRF] Photo Uploaded'
        constructor(public payload: { prf_uuid: string, photo: PrfPhoto }) {}
    }
    // prf/photos refused it (the line is gone or the PRF is completed).
    export class ApiPhotoDropped {
        static readonly type = '[API-PRF] Photo Dropped'
        constructor(public payload: { prf_uuid: string, photo_uuid: string }) {}
    }
    export class ApiPhotoDeleted {
        static readonly type = '[API-PRF] Photo Deleted'
        constructor(public payload: { prf_uuid: string, photo_uuid: string }) {}
    }
    // Everything for this PRF is on the server; clears is_pending_save unless
    // it was saved again since local_rev.
    export class ApiSyncedOne {
        static readonly type = '[API-PRF] Synced One'
        constructor(public payload: { uuid: string, local_rev: number | undefined }) {}
    }
}
